import { useMeasurementSignalsFor } from '../../../StateManagment/MeasurementSignalsContext'
import { formatWaitDuration, urgencyLabel, describeDue } from '../../../helpers/measurementSignals/describeSignal'

// AI-CONTEXT: See docs/features/meetmoment-signalering.md

/**
 * Welk meetmoment is bij dit huishouden het eerstvolgende, en wanneer?
 *
 * Voor de telefoon: één regel per gekoppeld onderzoek, geen kaart en geen
 * chips. De fixer aan de deur wil weten of hij vandaag een vragenlijst moet
 * laten invullen — de datum (zes weken na afronding van het traject) beantwoordt dat.
 *
 * Zwijgt zolang de gegevens onderweg zijn en als alles is ingevuld; alleen
 * een geweigerde read krijgt een melding, want stilte zou daar lezen als
 * 'niets aan de hand'.
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 *
 * Vereist een `MeasurementSignalsProvider` boven zich.
 *
 * @param {object} props
 * @param {string} props.adressID - `Adresses.ID` van het huishouden
 */
const HouseholdNextMomentNote = ({ adressID }) => {
    const { rows, loaded, unavailable } = useMeasurementSignalsFor(adressID)

    if (!loaded) return null

    if (unavailable.length > 0) {
        return (
            <p className='household-next-moment household-next-moment--warning'>
                De meetstand kon niet gelezen worden ({unavailable.join(', ')}).
            </p>
        )
    }

    const open = rows.filter((row) => row.next)
    if (open.length === 0) return null

    return (
        <ul className='household-next-moment-list'>
            {open.map((row) => (
                <li key={row.key} className='household-next-moment'>
                    <span className='household-next-moment-title'>{row.next.Title || 'Volgende meting'}</span>
                    <span className='household-next-moment-research'>{row.researchTitle}</span>
                    <span className={`measurement-signal-pill measurement-signal-pill--${row.urgency}`}>
                        {urgencyLabel(row.urgency)}
                    </span>
                    <span className='household-next-moment-when'>
                        {describeDue(row) || `staat al ${formatWaitDuration(row.openDays)} open`}
                    </span>
                </li>
            ))}
        </ul>
    )
}

export default HouseholdNextMomentNote
